import { styled } from '@mui/material';

export const Td = styled('td')(({ width }) => ({
  width,
}));
